import { motion } from "framer-motion";
import { FadeUp, MaskLine } from "./Reveal";

const REASONS = [
  {
    n: "01",
    title: "Small-batch roasting",
    text: "Beans roasted in small batches, never rushed — so the aroma reaches your cup the way it left the roaster.",
  },
  {
    n: "02",
    title: "Honest blends",
    text: "What we write on the pack is what is inside. No shortcuts, no filler — just carefully sourced coffee and tea.",
  },
  {
    n: "03",
    title: "For home & business",
    text: "From a 250 g home pack to wholesale supply for shops, cafés and canteens — the same quality in every bag.",
  },
  {
    n: "04",
    title: "People who answer",
    text: "Call, message or walk in — real support from people who know the product and stand behind it.",
  },
];

const WhyTMV = () => (
  <section id="why" data-testid="why-tmv-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="mb-14">
        <FadeUp>
          <p className="mb-5 text-[11px] uppercase tracking-widest2 text-sagelight">Why TMV</p>
        </FadeUp>
        <h2 className="font-display text-4xl leading-tight text-cream sm:text-5xl">
          <MaskLine delay={0.05}>Quietly done right,</MaskLine>
          <MaskLine delay={0.18} className="italic text-sagelight">
            in every cup.
          </MaskLine>
        </h2>
      </div>

      <div>
        {REASONS.map((r, i) => (
          <FadeUp key={r.n} delay={i * 0.06}>
            <motion.div
              className="group grid grid-cols-12 items-baseline gap-4 border-t border-cream/10 py-8 transition-colors duration-500 last:border-b hover:border-sagelight/50 md:items-center"
              whileHover={{ x: 8 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            >
              <span className="col-span-2 text-xs tracking-widest2 text-sagelight md:col-span-1">
                {r.n}
              </span>
              <h3 className="col-span-10 font-display text-2xl text-cream transition-colors duration-300 group-hover:text-gold md:col-span-4 md:text-3xl">
                {r.title}
              </h3>
              <p className="col-span-12 text-sm leading-relaxed text-cream/60 md:col-span-7 md:pl-8">
                {r.text}
              </p>
            </motion.div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default WhyTMV;
